import { CharacterType } from "typings/character";

export const characters = [
  0,
  1,
  2,
  3,
  4,
  5,
  6,
  7,
  8,
  9,
  "back",
  "complete",
] as CharacterType[];
